import { Link } from "react-router-dom";

export function KpiCard({ icon: Icon, label, val, i }) {
  return (
    <div className="card-federal p-6" data-testid={`kpi-${i}`}>
      <div className="flex items-center justify-between mb-4"><Icon className="w-5 h-5 text-[#0A192F]" /><span className="text-caption">{label}</span></div>
      <div className="font-serif text-4xl font-bold text-[#0A192F]">{val}</div>
    </div>
  );
}

export function RecentCasesPanel({ cases }) {
  return (
    <div className="card-federal p-6 lg:col-span-2">
      <div className="flex justify-between items-center mb-5">
        <h2 className="font-serif font-bold text-lg text-[#0A192F]">Recent Cases</h2>
        <Link to="/portal/cases" className="text-caption text-[#B91C1C]" data-testid="view-all-cases">View all</Link>
      </div>
      <div className="divide-y divide-slate-100">
        {cases.length === 0 && <div className="text-slate-500 text-sm py-4">No cases yet.</div>}
        {cases.map((c) => (
          <Link key={c.id} to={`/portal/cases/${c.id}`} className="flex items-center justify-between py-3 hover:bg-slate-50 -mx-2 px-2" data-testid={`recent-case-${c.id}`}>
            <div>
              <div className="font-serif text-[#0A192F]">{c.title}</div>
              <div className="text-xs text-slate-500 font-mono">{c.case_number}</div>
            </div>
            <span className="badge-federal">{c.status}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function StatusBreakdown({ byStatus, total }) {
  return (
    <div className="card-federal p-6">
      <h2 className="font-serif font-bold text-lg text-[#0A192F] mb-5">Status Breakdown</h2>
      <div className="space-y-3">
        {Object.entries(byStatus).length === 0 && <div className="text-slate-500 text-sm">No data</div>}
        {Object.entries(byStatus).map(([k, v]) => (
          <div key={k}>
            <div className="flex justify-between text-sm mb-1"><span className="capitalize text-slate-700">{k}</span><span className="font-mono text-slate-500">{v}</span></div>
            <div className="h-1.5 bg-slate-100"><div className="h-full bg-[#0A192F]" style={{ width: `${Math.min(100, (v / Math.max(1, total)) * 100)}%` }} /></div>
          </div>
        ))}
      </div>
    </div>
  );
}
